import { inject, Injectable, signal } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Observable } from 'rxjs';
import { RoomConfiguration, RoomConfigurationDto } from '@zayan-erp/home-building';

@Injectable({
  providedIn: 'root'
})
export class RoomConfigurationService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;
  estimatesToEdit = signal<RoomConfigurationDto | null>(null);

  saveRoomConfiguration(
    roomConfiguration: RoomConfiguration,
    projectId: string,
    projModelId: string
  ): Observable<unknown> {
    return this.#http.postData(
      `${this.baseUrl}/project/${projectId}/model/${projModelId}/rooms`,
      { showLoader: true, showMessage: true, message: 'Configuration Added Successfully' },
      roomConfiguration
    );
  }

  updateRoomConfiguration(
    roomConfiguration: RoomConfiguration,
    projectId: string,
    projModelId: string,
    projectModelRoomId: string
  ): Observable<unknown> {
    return this.#http.putData(
      `${this.baseUrl}/project/${projectId}/model/${projModelId}/rooms/${projectModelRoomId}`,
      roomConfiguration,
      { showLoader: true, showMessage: true, message: 'Configuration Updated Successfully' }
    );
  }

  /**
   * Flags a room as belonging to an alternate floor plan (or clears the flag).
   */
  toggleAlternate(
    projectId: string,
    projModelId: string,
    projectModelRoomId: string,
    alternate: boolean
  ): Observable<unknown> {
    return this.#http.patchData(
      `${this.baseUrl}/project/${projectId}/model/${projModelId}/rooms/${projectModelRoomId}/toggle-alternate`,
      { alternate },
      {
        showLoader: false,
        showMessage: true,
        message: alternate ? 'Location marked as alternate' : 'Location no longer marked as alternate'
      }
    );
  }

  getRoomConfiguration(projectId: string, projModelId: string): Observable<RoomConfigurationDto[]> {
    return this.#http.getData(`${this.baseUrl}/project/${projectId}/model/${projModelId}/rooms?IsActive=true`, {
      showLoader: true,
      showMessage: false
    });
  }

  deleteRoomConfiguration(projectModelRoomId: string): Observable<unknown> {
    return this.#http.deleteData(`${this.baseUrl}/project/model/rooms/${projectModelRoomId}`, {
      showLoader: true,
      showMessage: true,
      message: 'Configuration deleted successfully'
    });
  }

  getConfigurationByModelRoomId(projectModelRoomId: string): Observable<unknown> {
    return this.#http.getData(`${this.baseUrl}/project/model/rooms/${projectModelRoomId}`, {
      showLoader: true,
      showMessage: false
    });
  }
}
